import { render } from "./CreateAdmission.vue?vue&type=template&id=3785a82b&scoped=true&ts=true"
import script from "./CreateAdmission.vue?vue&type=script&lang=ts"
export * from "./CreateAdmission.vue?vue&type=script&lang=ts"

import "./CreateAdmission.vue?vue&type=style&index=0&id=3785a82b&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3785a82b"]])

export default __exports__